// import { backgroundImg } from "pages/ads/adverts/AdvertCard";

import { backgroundImageStyle } from "pages/Ads/Adverts/backgroundImageStyle";
import { createImageUrl } from "../../utils/publicationUrls/publicationUrls";

export const cardStyles = {
  // defaults for publication tiles
  default: {
    card: "bg-white text-dark",
    header: "text-primary",
    body: "",
    title: "h3 text-dark",
    footer: "",
    analyst: "text-primary font-weight-bold",
    synopsis: {},
  },

  // defaults for ad banners
  defaultBanner: {
    card: "text-white",
    padding: " px-2 px-md-5 pt-1 pb-2 ",
    title: " h3 mb-1 card-title ",
    titleIcon: " fas fa-2x fa-fw mr-1 ",
    footer: " mb-0 p-0 ",
    button: " bg-white text-primary btn-sm font-weight-bold ml-sm-5 ",
    leftImg: " advert-image ml-1 ml-md-3 ",
    rightImg: "advert-image mr-1 mr-md-3",
  },

  mobileBanner: {
    desc: "covid endgame, global research portal",
    card: "text-white",
    cardStyle: { backgroundPosition: "60% 50%" },
    header: "h2 font-weight-lighter",
    title: "h5 mb-0",
    rightImg: "ml-md-5",
    rightImgStyle: { width: "56px", height: "100%", marginTop: "-20px", marginBottom: "-20px" },
  },

  primaryAd: {
    desc: "podcast",
    card: "text-white font-weight-bold bg-primary pt-3 background-cover",
    title: "text-pre-wrap h3",
    titleStyle: { fontSize: "min(5.8vmin, 24pt)", lineHeight: 1.5 },
    footer: "py-0",
    footerStyle: { fontSize: "min(5.4vmin, 18pt)" },
    cardStyle: {
      textShadow: "0px 0px 2px red",
      backgroundPosition: "right",
    },
    gamma: 0,
  },

  sustainability: {
    desc: "sustainability",
    card: "text-white font-weight-bold sustainability",
    body: "mx-auto px-2 mx-md-3 justify-content-center",
    heading: "h4-sm h3 font-weight-bold",
    leftImg: "d-none d-sm-block ml-md-3",
    leftImgStyle: { width: "auto", height: "auto", marginBottom: "-14px", marginTop: "-14px", maxWidth: "165px" },
    centerImgStyle: { width: "165px" },
    centerImg: "d-block d-sm-none",
    footer: "py-0 font-weight-normal h5-sm h4",
    cardStyle: {
      textShadow: "0px 0px 2px #333",
      backgroundPosition: "left bottom",
      backgroundSize: "cover",
    },
    gamma: 0,
  },

  advertRedText2: {
    desc: "investor survey",
    card: "text-primary font-weight-bold background-contain background-cover-sm align-items-center",
    cardStyle: {
      textShadow: "auto",
      backgroundPosition: "right",
    },
    title: "font-weight-bold text-pre-wrap py-0 my-0 h3 h3-sm",
    footer: "h5 py-0 font-weight-normal d-flex justify-content-between w-100 mb-n4",
    buttonInline: "primary btn-sm py-1 ml-0 ml-md-auto mr-0 mt-1 text-nowrap",
    button: "bg-primary text-white text-nowrap py-1 px-1",
    body: "flex-grow-1",
    rhsStyle: { alignSelf: "flex-end" },
    gamma: 0,
  },

  advertRedWithWhiteShadow: {
    desc: "red text with white shadow on white background",
    card: "text-primary bg-white background-cover",
    cardStyle: {
      backgroundPosition: "center",
      textShadow: "white 2px 2px 2px",
    },
    heading: "h2 h3-sm mb-1",
    title: "h5 h5-sm mb-2 font-weight-normal",
    footer: "h5",
    buttonInline: "secondary h5 py-0",
    gamma: 0,
  },

  advertBlackTextWhiteShadow: {
    desc: "nikkei veritas survey",
    card: "bg-white text-dark background-contain background-cover-sm text-pre-wrap align-items-stretch",
    cardStyle: {
      textShadow: "1px 0px 2px #fff",
      backgroundPosition: "80% center",
    },
    body: "flex-grow-1",
    rhs: "d-none d-md-flex flex-column justify-content-between py-2",
    rhsStyle: { alignSelf: "stretch", alignItems: "flex-end" },
    title: "h5 font-weight-bold",
    footer: "h6",
    button: "mb-1 px-1 text-nowrap btn-sm text-white",
    mobileGamma: -1,
  },

  advertBlackTextWhiteShadowThin: {
    desc: "nikkei veritas survey",
    card: "bg-white text-dark background-contain background-cover-sm text-pre-wrap align-items-stretch",
    cardStyle: {
      textShadow: "auto",
      backgroundPosition: "80% center",
    },
    body: "flex-grow-1",
    rhs: "d-none d-md-flex flex-column justify-content-between py-3",
    rhsStyle: { alignSelf: "stretch", alignItems: "flex-end" },
    title: "h4 font-weight-normal maxw-490",
    footer: "h6",
    button: "mb-1 px-1 text-nowrap btn-sm text-white",
    buttonInline: "primary btn-sm d-block d-md-none py-1 px-0",
    mobileGamma: -1,
  },

  advertWhiteText2: {
    desc: "japanese banners (black)",
    card: "text-white text-pre-wrap",
    cardStyle: {
      backgroundPosition: "left",
      backgroundSize: "cover",
    },
    heading: "h4 h5-sm m-0 mb-2",
    title: "h1 h4-sm mb-0 font-weight-normal",
    footer: "h5 mb-1",
    gamma: 0,
  },

  advertWhiteOnRed: {
    desc: "white text on red background with RHS mountains",
    card: "text-white bg-primary background-contain background-cover-sm",
    cardStyle: {
      backgroundPosition: "right",
    },
    heading: "h2 h3-sm mb-1",
    title: "h5 h5-sm mb-2 font-weight-normal",
    buttonInline: "secondary h5 py-0",
    gamma: 0,
  },

  advertWhiteOnRedLargeFooter: {
    desc: "white text on red background with RHS mountains",
    card: "text-white bg-primary background-contain background-cover-sm",
    cardStyle: {
      backgroundPosition: "right",
    },
    heading: "h2 h3-sm mb-1",
    title: "h5 h5-sm mb-2 font-weight-normal",
    footer: "h5 font-weight-lighter",
    buttonInline: "secondary h5 py-0",
    gamma: 0,
  },

  advertWhiteOnRedLargeFooter2: {
    desc: "white text on red background with RHS mountains",
    card: "text-white bg-primary background-cover",
    cardStyle: {
      backgroundPosition: "right",
      textShadow: "1px 1px 2px black",
    },
    heading: "h2 h3-sm my-0",
    footer: "h3 h5-sm mt-0 mb-0",
    buttonInline: "secondary h5 py-0 d-none d-sm-inline-block ml-3",
    buttonStyle: { verticalAlign: "baseline" },
    gamma: 0,
  },

  advertWhiteOnRedNoteworthy: {
    desc: "white text on red background with RHS mountains",
    card: "text-white bg-primary background-cover",
    cardStyle: {
      backgroundPosition: "right",
    },
    heading: "h2 h3-sm mb-1 font-italic",
    footer: "h5 font-weight-lighter",
    buttonInline: "secondary h5 py-0",
    gamma: 0,
  },

  advertGeopolitics: {
    desc: "white text on red background with RHS mountains",
    card: "text-white bg-primary background-cover",
    cardStyle: {
      backgroundPosition: "right",
    },
    heading: "h2 h3-sm mb-1",
    title: "h5 h5-sm mb-2 font-weight-normal",
    buttonInline: "secondary h5 py-0",
    gamma: 0,
  },

  primary: {
    card: "bg-primary text-white",
  },

  secondary: {
    card: "bg-secondary text-white",
  },

  danger: {
    card: "bg-danger text-white",
  },

  info: {
    card: "bg-info text-white",
  },

  success: {
    card: "bg-success text-white",
  },

  dark: {
    card: "bg-dark text-white",
  },

  darkPromo: {
    card: "text-white border-0 background-cover bg-dark",
    cardStyle: backgroundImageStyle({ img: "banners/mountains-dark.svg" }),
    footer: "text-white",
  },

  image: {
    card: "text-white bg-secondary",
    synopsis: {},
  },

  secondaryAd: {
    card: "text-white font-weight-bold bg-secondary pt-3",
  },

  blueAd: {
    card: "text-white font-weight-bold pt-3",
    cardStyle: {
      background: "#00305C",
      textShadow: "0px 0px 2px blue",
      backgroundPosition: "right",
    },
  },

  greenAd: {
    card: "text-white font-weight-bold pt-3",
    cardStyle: {
      background: "#00713B",
      textShadow: "0px 0px 2px green",
      backgroundPosition: "right",
    },
  },

  grayGradient: {
    card: "text-white",
    cardStyle: { background: "linear-gradient(135deg, rgba(60,60,60,1) 1%, rgba(114,114,114,1) 100% )" },
  },

  intelligentGray: {
    card: "text-white",
    cardStyle: { background: "#737373" },
  },

  orangeGradient: {
    card: "bg-dark text-white",
    cardStyle: { background: "linear-gradient(darkorange, orange)" },
  },

  coverImage: (pid, filename = "coverImage.png") => ({
    card: "bg-dark text-white text-shadow background-cover",
    cardStyle: backgroundImageStyle({ img: createImageUrl(pid, filename), gamma: -0.4 }),
    analyst: "text-white font-weight-bold",
  }),

  bankingImage: (imgNum = (Math.random() * 199) << 0) => ({
    card: "bg-primary text-white text-shadow",
    cardStyle: backgroundImageStyle({ img: `banking and finance/${imgNum}.jpg` }),
    analyst: "text-white font-weight-bold",
    synopsis: {},
  }),
};

cardStyles.randomWhiteGray = (rand = Math.random()) => (rand > 0.7 ? cardStyles.intelligentGray : cardStyles.default);
cardStyles.randomWhiteRed = (rand = Math.random()) => (rand > 0.7 ? cardStyles.primary : cardStyles.default);
cardStyles.randomWhiteRedGray = (rand = Math.random()) =>
  rand > 0.7 ? cardStyles.primary : rand < 0.4 ? cardStyles.default : cardStyles.intelligentGray;

cardStyles.randomWhiteRedImage = (rand = Math.random()) =>
  rand > 0.7 ? cardStyles.primary : rand < 0.4 ? cardStyles.default : cardStyles.bankingImage();

cardStyles.random = () => {
  var keys = Object.keys(cardStyles);
  const style = cardStyles[keys[(keys.length * Math.random()) << 0]];
  return typeof style === "function" ? style() : style;
};
